export enum AvatarEvents {
  CLICKED_AVATAR_CONCENT = 'click_avatar_consent',
  SAVED_NEW_AVATAR = 'save_avatar', // pre-existing event logs
  CREATE_AVATAR_TOUR = 'avatar_tour',
}
